export default __webpack_public_path__ + "static/Varias06-02bf530163dc994556db7ab9f4b60659.svg";